import { all } from 'redux-saga/effects';

import { watchCaptchaSaga } from 'CorePackage/CaptchaModule/sagas/captchaSaga';
import { watchFeedbackSaga } from 'FeedbackPackage/MainModule/sagas/feedbackSaga';
import { watchNewsSaga } from 'NewsPackage/MainModule/sagas/newsSaga';
import { watchPublicOpenDataSaga } from 'OpenDataPackage/MainModule/sagas/publicOpenDataSaga';
import { watchPassportKnmSaga } from 'PassportKnmPackage/MainModule/sagas/passportKnmSaga';
import { watchSearchSaga } from 'SearchPackage/MainModule/sagas/searchSaga';
import { systemInoperabilitySaga } from 'NewsPackage/MainModule/sagas/systemInoperabilitySaga';

import { watchCoreSaga } from './coreSaga';

export function* rootSaga() {
  yield all([
    watchSearchSaga(),
    watchCaptchaSaga(),
    watchPassportKnmSaga(),
    watchFeedbackSaga(),
    watchNewsSaga(),
    watchPublicOpenDataSaga(),
    watchCoreSaga(),
    systemInoperabilitySaga(),
  ]);
}
